module.exports = __webpack_public_path__ + "img/sakarya-uni-logo.26b4f798.jpg";